import React from 'react';
import Participant from './Participant';

export default ({ event, participants }) => {
    const participant = (event) => participants[event.participant_id];

    return (
        <div className="event__panel">
            <div className="event__description">
                <strong>Substitution</strong>
            </div>
            {renderSubstitutionOn()}
            {renderSubstitutionOff()}
        </div>
    );

    function renderSubstitutionOn() {
        if (event.children.length) {
            return (
                <div className="event__description">
                    <span className="success">
                        <i className="fa fa-arrow-up"></i>
                        {' '}
                        <Participant participant={participant(event.children[0])}/>
                    </span>
                </div>
            );
        }
    }

    function renderSubstitutionOff() {
        return (
            <div className="event__description">
                <span className="danger">
                    <i className="fa fa-arrow-down"></i>
                    {' '}
                    <Participant participant={participant(event)}/>
                </span>
            </div>
        );
    }
};
